<template>
  <div>    
    <h1>Internet Explorer Not Supported</h1>
    <p>This website cannot be used with Internet Explorer.  Please use another browser such as FireFox, Chrome, or Edge to access this website.</p>
  </div>
</template>

<script>

export default {
  name: 'Unauthorized',
  components: {
  }
}
</script>
